import { gql, useQuery } from "@apollo/client";
import {
  QueryProjectById_solutions_Solutions_solution_Solution_projects_ProjectsViewModel_project_ProjectViewModel as Project,
  QueryProjectById,
  QueryProjectByIdVariables
} from "./schema/QueryProjectById";

export const queryProjectById = gql`
  query QueryProjectById($solutionKey: Key!, $projectId: ID!) {
    solutions {
      solution(solutionKey: $solutionKey) {
        key
        projects {
          project(projectId: $projectId) {
            databaseName
            description
            error
            id
            image
            name
            state
            tags
            databaseTemplateId
            databaseProgress
            workspaceId
            workspaceName
            isAvailable
          }
        }
      }
    }
  }
`;

export default function useQueryProjectById(
  variables: QueryProjectByIdVariables
) {
  return useQuery<QueryProjectById, QueryProjectByIdVariables>(
    queryProjectById,
    {
      variables,
      notifyOnNetworkStatusChange: true
    }
  );
}

export type { Project };
